<template>
  <div class="note col-12">
    <div class="card no-shadow">
      <div class="card-body">
        <i
          @click="delNote()"
          class="fa fa-trash float-right text-danger fa-lg interactive-cursor">
        </i>
        <i
          @click="editNote()"
          class="fa fa-edit float-right text-primary fa-lg interactive-cursor">
        </i>
        <h4 class="mb-0">
          {{ note.subject }}
        </h4>
        <span class="text-muted">
          {{ note.createdAt | short_date_time_format }} - {{ note.Author.fullName }}
        </span>
        <hr/>
        <p class="mt-3 mb-0">
          {{ note.description }}
        </p>
        <div v-if="note.Attachments && note.Attachments.length" class="mt-2 row">
          <template v-for="image in note.Attachments">
            <div class="col-lg-4 text-center" :key="image.uuid">
              <img :src="'https://s3-ap-southeast-2.amazonaws.com/roscon/' + image.objectKey" class="img-thumbnail img-fluid my-1 mr-2" />
              <download-input
                :options="{ permalink: 'downloadFile'}"
                :value="{ objectKey: image.objectKey }" />
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import DownloadInput from '@/components/inputs/DownloadInput'
  import {
    EDIT_NOTE,
    DELETE_NOTE
  } from '@/vuex/types'
  export default {
    name: 'Note',
    props: {
      object: {
        type: Object,
        default () {
          return {}
        }
      }
    },
    components: {
      DownloadInput
    },
    computed: {
      note () {
        return {
          Attachments: [],
          Author: {},
          ...this.object
        }
      }
    },
    methods: {
      async delNote () {
        await this.$store.dispatch(DELETE_NOTE, this.note.uuid)
      },
      async editNote () {
        await this.$store.dispatch(EDIT_NOTE, this.note.uuid)
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/displays/Note.vue